/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Property_Lustrace_Subjects_HintInputs */

const cs_property_lustrace_subjects_hint = /** @type {(inputs: Property_Lustrace_Subjects_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Použito ${i?.count} stran z této nemovitosti.`)
};

const en_property_lustrace_subjects_hint = /** @type {(inputs: Property_Lustrace_Subjects_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Using ${i?.count} parties from this property.`)
};

/**
* | output |
* | --- |
* | "Using {count} parties from this property." |
*
* @param {Property_Lustrace_Subjects_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_lustrace_subjects_hint = /** @type {((inputs: Property_Lustrace_Subjects_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Lustrace_Subjects_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_lustrace_subjects_hint(inputs)
	return cs_property_lustrace_subjects_hint(inputs)
});